'use client';
import React, { useEffect, useState } from 'react';
import { EcwidProduct } from '@/lib/ecwid/ecwidTypes';
import { VariantSelector } from './VariantSelector';
import Price from '../price';
import { useVariantStore } from '../useVariantStore';
import { AddProductToCart } from './AddProductToCart';
import { loadEcwidScript } from '../checkout/utils';
import { ProductDescriptionType } from '@/app/[locale]/admin/ecwid-products/[id]/SectionEditor';

export function ProductDescription({
    product,
    productDescription,
    translation,
}: {
    product: EcwidProduct;
    productDescription: ProductDescriptionType;
    translation: Record<string, string>;
}) {
    const { selectedVariant } = useVariantStore();
    const [ecwidLoaded, setEcwidLoaded] = useState(false);

    useEffect(() => {
        loadEcwidScript(process.env.NEXT_PUBLIC_ECWID_STORE_ID, () => {
            setEcwidLoaded(true);
        });
    }, []);

    return (
        <div className="relative ml-2">
            <div className="mb-6 flex flex-col border-b pb-6 dark:border-neutral-700">
                <h1 className="mb-2 text-3xl xl:text-4xl text-neutral-800 font-medium">
                    {product.name}
                </h1>
                <div className="flex items-center">
                    <div className="rounded-full bg-primary-accent p-2 text-lg text-white">
                        <Price
                            amount={
                                selectedVariant?.defaultDisplayedPrice ||
                                product.price
                            }
                            className="p-1"
                            currencyCode="CAD"
                        />
                    </div>
                    {product.compareToPrice &&
                        product.compareToPrice > product.price && (
                            <p className="text-gray-700 line-through decoration-red-700 text-xl ml-4">
                                {new Intl.NumberFormat('fr-CA', {
                                    style: 'currency',
                                    currency: 'CAD',
                                    currencyDisplay: 'narrowSymbol',
                                }).format(product.compareToPrice)}
                            </p>
                        )}
                </div>
                {productDescription?.shortDescription && (
                    <div
                        className="mb-4 mt-4 ml-4 mr-4 text-xl font-medium"
                        dangerouslySetInnerHTML={{
                            __html: productDescription?.shortDescription,
                        }}
                    />
                )}
            </div>
            <VariantSelector
                combinations={product.combinations}
                options={product.options}
            />
            <div className="my-8">
                {ecwidLoaded ? (
                    <AddProductToCart translation={translation} />
                ) : null}
            </div>
        </div>
    );
}
